import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import IframeModal from '../../GlobalModals/IframeModal'
import { onDemandCategories } from '../categories'

export const CategorySelection: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  const [playVideo, setPlayVideo] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const { muted } = useSelector((state) => state.layout)

  useEffect(() => {
    dispatch(setPageTitle('Video Gallery'))
    dispatch(setPreviousPage(routes.lobby))
  }, [dispatch])

  const onClick = (item) => {
    Amplitude.clickGalleryVideo(item.title)
    Amplitude.clickGalleryVideoTemp(item.title)
    setIsOpen(true)
    setPlayVideo({
      title: item.title,
      link: item.destination,
    })
  }
  return (
    <>
      <div className="grid-container">
        {onDemandCategories.map((item) => {
          return (
            <>
              <div key={item.id} onClick={() => onClick(item)} className="card-thumbnail">
                <img src={item.thumbnail} width="100%" alt="thumbnail" />
              </div>
            </>
          )
        })}
      </div>
      {isOpen && <IframeModal iframeOpen={isOpen} setIframeOpen={setIsOpen} iframe={playVideo} />}
    </>
  )
}
